import { FC } from 'react';

import { Container, Notification } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

export const PlansListErrorNotification: FC = () => {
    const { t } = useTranslations();

    return (
        <Container>
            <Notification status="error" heading={t['common.error_notification.heading']} headingTag="h2">
                {t['common.error_notification.general_error']}
            </Notification>
        </Container>
    );
};
